export default __webpack_public_path__ + "259df02ca331ed60cce99e2586160876.svg";